import { NDSProvider } from "@nulogy/components";
import React from "react";
import ReactDOM from "react-dom/server";

const renderToString = (jsxFragment) =>
  ReactDOM.renderToString(<NDSProvider disableGlobalStyles>{jsxFragment}</NDSProvider>);

export default renderToString;
